import { useEffect, useState } from "react";
import { ReactCompareSlider, ReactCompareSliderImage } from "react-compare-slider";
import { api, imgUrl, isVideo } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { Reveal } from "../components/Reveal";
import { PageHero } from "./AboutPage";
import { Seo } from "../components/Seo";
import { PAGE_SEO } from "../lib/seo";

export default function BeforeAfterPage() {
  const [items, setItems] = useState([]);
  const { L } = useSite();
  useEffect(() => { api.get("/before_after").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <main data-testid="before-after-page">
      <Seo title={PAGE_SEO.beforeAfter.title} description={PAGE_SEO.beforeAfter.description} path="/before-after" />
      <PageHero overline={L.baPage.overline} title={L.baPage.title}
        subtitle={L.baPage.subtitle} />
      <section className="py-20 bg-[#F8FAFC]">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 space-y-20">
          {items.length === 0 && <p className="text-slate-500 py-20 text-center">{L.baPage.empty}</p>}
          {items.map((p, i) => (
            <Reveal key={p.id} delay={0.05}>
              {isVideo(p.before_image) || isVideo(p.after_image) ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 bg-black" data-testid={`ba-media-${i}`}>
                  {[["before_image", L.baPage.before], ["after_image", L.baPage.after]].map(([key, label]) => (
                    <div key={key} className="relative" style={{ height: "min(50vh, 420px)" }}>
                      {isVideo(p[key])
                        ? <video src={imgUrl(p[key])} controls muted playsInline className="w-full h-full object-cover" />
                        : <img src={`${imgUrl(p[key])}?w=1400&q=75`} alt={`${p.title} — ${label}`} className="w-full h-full object-cover" />}
                      <span className="absolute top-3 left-3 bg-black/60 text-white text-xs uppercase tracking-widest px-3 py-1 font-heading font-bold pointer-events-none">{label}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div data-testid={`ba-slider-${i}`}>
                  <ReactCompareSlider
                    itemOne={<ReactCompareSliderImage src={`${imgUrl(p.before_image)}?w=1400&q=75`} alt={`${p.title} — before`} />}
                    itemTwo={<ReactCompareSliderImage src={`${imgUrl(p.after_image)}?w=1400&q=75`} alt={`${p.title} — after`} />}
                    style={{ height: "min(65vh, 560px)" }}
                  />
                </div>
              )}
              <div className="mt-6">
                <p className="text-[#005AE0] font-heading text-xs uppercase tracking-widest font-bold mb-1">
                  {p.service}{p.location ? ` • ${p.location}` : ""}
                </p>
                <h2 className="font-heading font-bold text-[#0B1B3D] text-2xl">{p.title}</h2>
                {p.description && <p className="text-slate-500 mt-2 leading-relaxed">{p.description}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
